/**
 * CompareTruncatedNotice — Mention affichée au-dessus de la comparaison quand
 * l'URL portait plus de MAX_COMPARE_SESSIONS identifiants (cf. compareIds.js).
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { semanticColors } from '../constants/semanticColors';
import { MAX_COMPARE_SESSIONS } from './compareIds';

export default function CompareTruncatedNotice({ darkMode = false }) {
  const { t } = useTranslation();
  return (
    <p role="status" data-testid="compare-truncated"
      style={{ maxWidth: '1000px', margin: '0 auto 12px', padding: '10px 14px', borderRadius: '8px',
        fontSize: '13px', fontWeight: '500',
        background: darkMode ? 'transparent' : semanticColors.amberBg,
        border: `1px solid ${semanticColors.amberText}`,
        color: darkMode ? semanticColors.amberSolid : semanticColors.amberText }}>
      {t('sessions.compare.truncated', { max: MAX_COMPARE_SESSIONS })}
    </p>
  );
}
